import { makeStyles } from "@material-ui/core";

export default makeStyles(
  () => ({
    placeholder: {
      margin: [0, "auto", 20],
      maxWidth: 400,
    },
  }),
  { name: "InputPlaceholder" },
);
